function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m139.323 379.455 137.26 43.425v-44.356l-100.385-31.759c-10.573 12.658-23.007 23.709-36.875 32.69z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m328.328 469.968h42.291v42.032h-42.291z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m306.583 394.146h85.782v45.822h-85.782z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m418.069 47.482c-44-30.851-95.763-47.269-149.692-47.48-.346-.002-.704-.002-1.05-.002-69.696 0-135.414 27.191-185.174 76.643-49.995 49.685-77.617 115.631-77.777 185.689-.092 39.837 8.451 77.978 25.406 113.507h20.224c22.973 0 45.706-5.939 65.743-17.177s36.959-27.538 48.938-47.14c14.652-23.979 35.353-43.918 59.862-57.663 24.51-13.746 52.317-21.012 80.418-21.012h26.271c22.186 0 44.236-5.564 63.767-16.091l112.62-60.7c-19.386-43.594-50.143-80.94-89.556-108.574z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m331.238 262.848h-2.909v101.298h42.29v-106.113c-12.86 3.174-26.1 4.815-39.381 4.815z"
}));

function SvgHelmetUnlockedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmetUnlockedIcon);
export default __webpack_public_path__ + "static/media/helmet-unlocked-icon.fda19267.svg";
export { ForwardRef as ReactComponent };